export const styles = {
  dialog: {
    backgroundColor: "transparent",
    p: 0,
    maxWidth: "1200px",
  },
  leftContent: {
    flex: 1.5,
    background:
      "linear-gradient(to bottom,rgba(255,205,0,1) 0%,rgba(255,95,0,1) 100%)",
    height: "calc(100% - 40px)",
    mt: 2.5,
    borderRadius: "10px 0 0 10px",
    position: "relative",
  },
  rightContent: {
    flex: 1,
    borderRadius: 1.25,
    overflow: "hidden",
    height: "100%",
    boxShadow: "0 0 17px 0 rgba(0,0,0,.75)",
    position: "relative",
  },
  content: {
    p: 0,
    backgroundColor: "transparent",
    height: "90vh",
    maxHeight: "600px",
    minHeight: "300px",
  },
  message: (theme) => ({
    textAlign: "center",
    color:
      theme.palette.mode === "dark"
        ? theme.palette.common.black
        : theme.palette.common.white,
  }),
  messageBox: {
    height: "calc(100% - 70px)",
    alignItems: "center",
    justifyContent: "center",
    wordBreak: "break-word",
    px: 1,
  },
  mainContent: {
    height: "100%",
  },
  avatar: {
    position: "absolute",
    top: 15,
    left: 15,
    width: 100,
    height: 100,
  },
  acceptButton: (theme) => ({
    textTransform: "capitalize",
    backgroundColor: theme.palette.background.default,
    color: theme.palette.common.black,
    alignSelf: "center",
    p: "5px 20px",
    boxShadow: "0 0 17px 0 rgba(0,0,0,.55)",
    minWidth: "100px",
    "&:hover": {
      backgroundColor: theme.palette.background.default,
    },
  }),
  replyButton: (theme) => ({
    backgroundColor: "transparent",
    color:
      theme.palette.mode === "dark"
        ? theme.palette.common.black
        : theme.palette.common.white,
    boxShadow: "none",
    my: 0.5,
    "&:hover": {
      backgroundColor: "transparent",
    },
  }),
}
